import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "coupons",
    object: "coupon",
    header: [
      { text: "Name", value: "name" },
      { text: "Discount", value: "discount" },
      { text: "Code", value: "code" },
      { text: "Region", value: "region_id" },
      { text: "Product", value: "product_id" },
      { text: "Only First purchase", value: "only_first_purchase" },
      { text: "Init time", value: "init_time" },
      { text: "Finish time", value: "finish_time" },
       // { text: "Sponsored brand", value: "category_id" },
      { text: "", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
